import React, { useEffect, useState } from 'react';
import type { TextInputProps } from '@interstate/components/TextInput';
import { TextInput } from '@interstate/components/TextInput';
import type { InterstateOnChangeEvent } from '@interstate/components/InterstateEvents';

interface MaskTextInputProps extends Omit<TextInputProps, 'onChange'> {
    onChange: (field: string, value: string) => void;
    maskedValue: string;
    defaultMask: boolean;
    masking?: any;
}

const MaskTextInput: React.FC<MaskTextInputProps> = ({
    onChange,
    maskedValue,
    defaultMask,
    value,
    name,
    masking,
    ...textInputProps
}) => {
    const [realValue, setRealValue] = useState(value || '');

    function buildMaskedValue() {
        return realValue ? '*'.repeat(realValue.length) : defaultMask ? maskedValue : '';
    }

    const [displayValue, setDisplayValue] = useState(buildMaskedValue());

    useEffect(() => {
        if (!realValue) {
            setDisplayValue(defaultMask ? maskedValue : '');
        }
    }, [defaultMask, maskedValue, realValue]);

    const handleChange = (event: InterstateOnChangeEvent<string>) => {
        let inputValue = event.target.value;
        inputValue = inputValue.replace(/_/g, '');

        if (inputValue === buildMaskedValue() || inputValue === '' || inputValue === realValue) return;
        onChange(name, inputValue);
        setRealValue(inputValue);
        setDisplayValue(inputValue);
    };

    const handleFocus = () => {
        setDisplayValue('');
    };

    const handleBlur = () => {
        setDisplayValue(buildMaskedValue());
    };

    return (
        <TextInput
            {...textInputProps}
            name={name}
            value={displayValue}
            masking={masking}
            onChange={handleChange}
            onFocus={handleFocus}
            onBlur={handleBlur}
        />
    );
};

export default MaskTextInput;
